enum ClaimStatus {
    Submitted = 'Submitted',
    PendingValidation = 'PendingValidation',
    PotentialDuplicate = 'PotentialDuplicate',
    Incomplete = 'Incomplete',
    Issued = 'Issued', // Remove eventually? Temporarily here while we transition to new statuses
    Disqualified = 'Disqualified',
    Validated = 'Validated',
    PendingExport = 'PendingExport', // Remove eventually? Temporarily here while we transition to new statuses
    Exported = 'Exported', // Remove eventually? Temporarily here while we transition to new statuses
    Mailed = 'Mailed', // Remove eventually? Temporarily here while we transition to new statuses
    PendingRedemption = 'PendingRedemption',
    ConfirmingReferral = 'ConfirmingReferral',
    NeedsReview = 'NeedsReview',
    Fulfilled = 'Fulfilled',
    Executing = 'Executing',
}

export default ClaimStatus;
